import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";

const DisclaimerPopup = ({ isOpen, onRequestClose}) => {
    
    const navigate = useNavigate();
    const handleBookAppointment = () => {
        navigate('/users/book-appointment');
      };

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Disclaimer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
        Executive annual Medicals for AL are facilitated by TMPL, 
        providing multiple medical facilities across India for the convenience of executives.
         The choice of the available center lies with the executive. 
         All processes followed by the selected center must be adhered to by the executive meticulously, 
         for best results. 
        </p>

        <p>
        TMPL has no role in the execution of specified tests or 
         reporting by the center based on the results; 
         this interaction is solely between the executive and the center. 
         Positive identification is mandatory between the center and the executive. 
         Any additional tests require approval by the respective HR. 
         TMPL is only responsible for scheduling appointments through its portal and access of reports by the center to authorized personnel.
        </p>
       
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="me-3" onClick={onRequestClose}>
          Decline
        </Button>
        <Button variant="primary" onClick={handleBookAppointment}>
          Accept
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DisclaimerPopup;
